import React, {ReactNode} from "react";
import cx from "classnames";

export function FilterModalField(props: { children: ReactNode, fullRow?: boolean, inLine?: boolean, removeMargin?: boolean }) {
    return <div
        className={cx("flex", props.fullRow && "col-span-1 md:col-span-2", (props.inLine ? "flex-row gap-4" : "flex-col gap-2"), (!props.removeMargin && "mb-4"),)}>
        {props.children}
    </div>
}